import React from "react";
import {Brands} from "@core-ui/utility";
import {ResponsiveIcon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandLargeViewBoxSVG = (
  <svg
    height="32"
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z"
      fill="#F2F2F2"
    />
    <path d="M11 9.913c0-.864.923-1.416 1.685-1.006l11.303 6.087a1.143 1.143 0 010 2.012l-11.303 6.087A1.143 1.143 0 0111 22.087V9.913z" />
  </svg>
);

const CrossBrandSmallViewBoxSVG = (
  <svg
    height="48"
    viewBox="0 0 48 48"
    width="48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24z"
      fill="#F2F2F2"
    />
    <path d="M16 14.87a1.714 1.714 0 012.527-1.51l16.956 9.13c1.202.648 1.202 2.372 0 3.02l-16.956 9.13A1.714 1.714 0 0116 33.13V14.87z" />
  </svg>
);

const brandIconLargeViewBoxSVGs = {
  [Brands.Athleta]: CrossBrandLargeViewBoxSVG,
  [Brands.BananaRepublic]: CrossBrandLargeViewBoxSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandLargeViewBoxSVG,
  [Brands.Gap]: CrossBrandLargeViewBoxSVG,
  [Brands.GapFactoryStore]: CrossBrandLargeViewBoxSVG,
  [Brands.OldNavy]: CrossBrandLargeViewBoxSVG,
  crossBrand: CrossBrandLargeViewBoxSVG,
};

const brandIconSmallViewBoxSVGs = {
  [Brands.Athleta]: CrossBrandSmallViewBoxSVG,
  [Brands.BananaRepublic]: CrossBrandSmallViewBoxSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandSmallViewBoxSVG,
  [Brands.Gap]: CrossBrandSmallViewBoxSVG,
  [Brands.GapFactoryStore]: CrossBrandSmallViewBoxSVG,
  [Brands.OldNavy]: CrossBrandSmallViewBoxSVG,
  crossBrand: CrossBrandSmallViewBoxSVG,
};

export const PlayCircleIcon = (props: IconContainerProps): JSX.Element => (
  <ResponsiveIcon
    {...props}
    brandIconLargeViewBoxSVGs={brandIconLargeViewBoxSVGs}
    brandIconSmallViewBoxSVGs={brandIconSmallViewBoxSVGs}
  />
);
